import { Components } from '@mui/material'

const MuiFormComponents: Components = {
  MuiInputLabel: {
    styleOverrides: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      root: ({ theme }: { theme: any }) => ({
        color: theme.palette.grey[500],
        fontWeight: 600,
        fontSize: '14px',
        '&.Mui-error': {
          color: theme.palette.grey[500],
        },
      }),
    },
  },
  MuiTextField: {
    styleOverrides: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      root: ({ theme }: { theme: any }) => ({
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: theme.palette.grey[300],
          },
          '&:hover fieldset': {
            borderColor: theme.palette.grey[300],
          },
          '&.Mui-focused fieldset': {
            borderColor: theme.palette.grey[300],
          },
          '&.Mui-error fieldset': {
            borderColor: theme.palette.error.main,
          },
          '&.Mui-error:hover fieldset': {
            borderColor: theme.palette.error.main,
          },
          '&.Mui-error.Mui-focused fieldset': {
            borderColor: theme.palette.error.main,
          },
        },
        '& .MuiFormHelperText-root': {
          color: theme.palette.error.main,
          '&.Mui-error': {
            color: theme.palette.error.main,
          },
        },
      }),
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      root: ({ theme }: { theme: any }) => ({
        color: theme.palette.grey[500],
        '&.Mui-error': {
          color: theme.palette.grey[500],
        },
      }),
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      root: ({ theme }: { theme: any }) => ({
        '& fieldset': {
          borderColor: theme.palette.grey[300],
        },
        '&:hover fieldset': {
          borderColor: theme.palette.grey[300],
        },
        '&.Mui-focused fieldset': {
          borderColor: theme.palette.grey[300],
        },
        '&.Mui-error fieldset': {
          borderColor: theme.palette.error.main,
        },
        '&.Mui-error:hover fieldset': {
          borderColor: theme.palette.error.main,
        },
        '&.Mui-error.Mui-focused fieldset': {
          borderColor: theme.palette.error.main,
        },
      }),
    },
  },
}

export default MuiFormComponents
